import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { FaBoxOpen, FaCartShopping, FaMoneyBillTransfer } from "react-icons/fa6";
import { FaSignOutAlt, FaBars, FaUsersCog } from "react-icons/fa";
import { RiDashboardFill } from "react-icons/ri";

const DashboardAffiliateLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [profile, setProfile] = useState<{
    name: string;
    role: string;
    photo: string | null;
  } | null>(null);

  const handleLogout = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });

    window.location.href = "/";
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = document.cookie
          .split("; ")
          .find((row) => row.startsWith("token="))
          ?.split("=")[1];

        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/affiliate/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (!res.ok) throw new Error("Gagal mengambil profil");

        const data = await res.json();

        setProfile({
          name: data.name,
          role: data.role,
          photo: data.photo ? `${process.env.REACT_APP_STORAGE_URL}/profile/${data.photo}` : null,
        });
      } catch (err) {
        console.error("Gagal fetch profile:", err);
      }
    };

    fetchProfile();
  }, []);

  return (
    <>
      <div className="flex min-h-screen bg-gray-100 font-signika">
        {/* SIDEBAR */}
        <aside
          className={`fixed top-0 left-0 z-40 h-screen w-64 bg-black2 text-white p-5
          transform transition-transform duration-300
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0`}>
          <div className="">
            <img src="/images/logo.png" alt="logo" className="w-40" />
          </div>
          <div className="mb-8 font-semibold text-primary2 text-xl font-edu">Affiliate Dashboard</div>

          <nav className="flex flex-col gap-2 text-lg">
            <NavLink
              to="/dashboard-affiliate/beranda"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md transition
                ${isActive ? "bg-yellow-400/20 text-yellow-400 font-semibold" : "hover:text-yellow-400"}`
              }
              onClick={() => setSidebarOpen(false)}>
              <RiDashboardFill />
              Beranda
            </NavLink>

            <NavLink
              to="/dashboard-affiliate/produk"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md transition
                ${isActive ? "bg-yellow-400/20 text-yellow-400 font-semibold" : "hover:text-yellow-400"}`
              }
              onClick={() => setSidebarOpen(false)}>
              <FaBoxOpen />
              Produk Link
            </NavLink>

            <NavLink
              to="/dashboard-affiliate/order"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md transition
                ${isActive ? "bg-yellow-400/20 text-yellow-400 font-semibold" : "hover:text-yellow-400"}`
              }
              onClick={() => setSidebarOpen(false)}>
              <FaCartShopping />
              Order
            </NavLink>

            <NavLink
              to="/dashboard-affiliate/withdraw"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md transition
                ${isActive ? "bg-yellow-400/20 text-yellow-400 font-semibold" : "hover:text-yellow-400"}`
              }
              onClick={() => setSidebarOpen(false)}>
              <FaMoneyBillTransfer />
              Withdraw
            </NavLink>

            <NavLink
              to="/dashboard-affiliate/akun"
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md transition
                ${isActive ? "bg-yellow-400/20 text-yellow-400 font-semibold" : "hover:text-yellow-400"}`
              }
              onClick={() => setSidebarOpen(false)}>
              <FaUsersCog />
              Account
            </NavLink>

            <button onClick={handleLogout} className="flex items-center gap-3 px-3 py-2 text-red-400 hover:text-red-500 mt-6">
              <FaSignOutAlt />
              Logout
            </button>
          </nav>
        </aside>

        {/* MAIN */}
        <div className="flex-1 flex flex-col lg:ml-64 min-w-0">
          {/* HEADER */}
          <header className="bg-white shadow sticky top-0 z-30">
            <div className="flex items-center justify-between px-4 py-3">
              {/* Burger */}
              <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-xl lg:hidden">
                <FaBars />
              </button>

              <div></div>

              {/* PROFILE */}
              <div className="flex items-center gap-3">
                {profile ? (
                  <>
                    <img src={profile.photo ?? "https://ui-avatars.com/api/?name=" + encodeURIComponent(profile.name)} alt="profile" className="w-10 h-10 rounded-full object-cover" />

                    <div className="text-right hidden sm:block">
                      <p className="text-sm font-semibold text-gray-800">{profile.name}</p>

                      <p className="text-xs text-gray-500 capitalize">Affiliate</p>
                    </div>
                  </>
                ) : (
                  <p className="text-sm text-gray-500">Loading...</p>
                )}
              </div>
            </div>
          </header>

          {/* CONTENT */}
          <main className="p-4 flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>

      {/* OVERLAY MOBILE */}
      {sidebarOpen && <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setSidebarOpen(false)} />}
    </>
  );
};

export default DashboardAffiliateLayout;
